import {apiService} from '@app/services/api.service';


class VaultFoldersServiceNew {
    readonly apiBase: string = '/api/v1/pm/vaults';

    addVaultFolder(vaultId: string, jsonObject: any, handleError: Function, handleSuccess: Function) {
        return apiService.post(`${this.apiBase}/${vaultId}/folders`,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess }
        )
            .catch();
    }
}

export const vaultFoldersServiceNew = new VaultFoldersServiceNew();
